<template>
  <section class="page-basket my-5">
    <modal-bill :show="isPayment" @hiddenModal="hidePayment"/>
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="table-responsive-md">
            <table class="table table-bordered table-striped bg-white text-center">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>نام محصول</th>
                  <!-- <th>توضیحات</th> -->
                  <th>قیمت</th>
                  <th>عملیات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in basketList" :key="index" class="align-middle">
                  <th class="pb-0" scope="row">{{index + 1}}</th>
                  <td class="pb-0">
                    <router-link
                      :to="'/courses/'+item.en_category +'/'+ item.en_subcategory +'/'+ item.id + '/' + item.title"
                    >{{item.name}}</router-link>
                  </td>
                  <!-- <td class="pb-0">توضیحات توضیحات توضیحات </td> -->
                  <td class="pb-0">{{item.price | currency}}</td>
                  <td class="text-center pb-1 pt-1">
                    <button
                      class="bttn-material-circle bttn-md bttn-danger text-center"
                      v-ripple
                      @click="remove(item,index)"
                      :title="$t('button.removeCard')"
                    >
                      <i class="mdi flaticon-dustbin"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th scope="row"></th>
                  <td colspan="2">مجموع</td>
                  <td>{{sumPrice | currency}}</td>
                  <td class="text-center p-0 pt-1">
                    <button
                      v-if="basketList.length > 0"
                      class="bttn-fill bttn btn-block bttn-success"
                      v-ripple
                      @click="isPayment = true"
                      :title="$t('button.submitCard')"
                    >
                      <i class="mdi mdi-basket-unfill"></i>
                      {{$t('button.submitCard')}}
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ModalBill from "../components/min-component/modal-bill";
export default {
  name: 'page-basket',
  components: {ModalBill},
  data() {
    return {
      isClicked:false,
      isLoading:false,
      isPayment: false

    }
  },
  computed: {
    basketList() {
      return this.$store.state.basket.basketList
    },
    sumPrice() {
      let basketList = this.$store.state.basket.basketList
      let prices = basketList.map(e => e.price)
      return Number(prices.reduce((a, b) => a + b, 0))
    }
  },
  methods: {
    remove(item, index) {
      this.$delete(this.basketList, index)
      this.$store.commit("basket/SET_DATA", { data: this.basketList.length, id: "lenghtBasketCard" });

      localStorage.setItem('shoppingCard', JSON.stringify(this.basketList))
    },
    showPayment(){
      this.isPayment = true
    },
    hidePayment(){
      this.isPayment = false;
    },
  }
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/basket.vue